export default __webpack_public_path__ + "static/img3-415f378bc293678376f296aa1fabc390.jpg";